import { useState, useContext, useEffect } from "react";
import { FaEdit, FaGlobe, FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import Dialogs from "components/ui/dialogs/dialogs";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import RemExpressOptiRemPage from "./remExpressOptiRem";
import RemExpressArbitragePage from "./remExpressArbitrage";

const RemExpressSimulationPage = (props) => {
  const context = useContext(AppContext);
  const [clientConjoint, setClientConjoint] = useState("");
  const [modalOpen, setmodalOpen] = useState(false);
  const [modalOpenArbitrage, setmodalOpenArbitrage] = useState(false);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);
  const Periode = context.state["PeriodeActuelle"][0];
  const PeriodeConjoint = context.state["PeriodeActuelleConjoint"][0];
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    context.handleOpenRemiseDonneeRemExpressOptirem(ResultatTNS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Column fill>
        <Row>
          <Column fill>
            <CardBox bpad>
              <Column fill>
                <Row>
                  <h1>Liste des simulations réalisées</h1>
                </Row>
                <Row center>
                  <Column style={{ paddingLeft: 0 }}>
                    <Button style={{minWidth:"200px"}}
                      onClick={() => {
                        // setClientConjoint("");
                        context.handleResetOptimisation();
                        context.handleOpenRemiseDonneeRemExpressOptirem(ResultatTNS);
                        setmodalOpen(true);
                      }}
                    >
                      <span>Gestionnaire de scénarios</span>
                      <FaPlusCircle />
                    </Button>
                    </Column>
                    <Column>
                    <Button
                    style={{minWidth:"200px"}}
                      onClick={() => {
                        // setClientConjoint("");
                        context.handleResetOptimisation();
                        context.handleOpenRemiseDonneeRemExpressOptirem(ResultatTNS);
                        setmodalOpenArbitrage(true);
                      }}
                    >
                      <span>Arbitrage</span>
                      <FaPlusCircle />
                    </Button>
                  </Column>
                </Row>
                <Row tpad>
                  <table>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Libellé</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {context.state.ListeOptimisation.map((Infos, Index) => {
                        var date = new Date(Infos.DateAdd);
                        var year = date.getFullYear();
                        var month = (1 + date.getMonth()).toString();
                        month = month.length > 1 ? month : "0" + month;
                        var day = date.getDate().toString();
                        day = day.length > 1 ? day : "0" + day;
                        date = day + "/" + month + "/" + year;

                        return (
                          <tr key={Index}>
                            <td>{date}</td>
                            <td>{Infos.LibelleOptimisation}</td>
                            <td>
                              <Button
                                onClick={() => {
                                  // setClientConjoint("");
                                  context.handleAccesOptimisation(Infos.IdOptimisation, ResultatTNS);
                                  setmodalOpen(true);
                                  // context.handleModifyDeletePeriodeRetraite(Infos.id, "Modifier", "", "");
                                  // setmodalPeriodeRetr(true);
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaEdit />
                              </Button>
                              <Button
                                onClick={() => {
                                  // setClientConjoint("");
                                  Dialogs.confirm("Vous êtes sur le point de supprimer la simulation.\nVoulez-vous continuer ?", "Suppression d'une simulation", () => {
                                    context.handleDeleteOptimisation(Infos.IdOptimisation);
                                  });
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaTrashAlt className="delete" />
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Row>
              </Column>
            </CardBox>
          </Column>
        </Row>
      </Column>

      <Modal
        width="90%"
        height="90%"
        title="Optimisation de l'existant"
        icon={<FaGlobe />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        {context.state.OptiRemListeContrat !== undefined && (
          <RemExpressOptiRemPage
            ClientConjoint={""}
            visible={modalOpen}
            onClose={() => {
              setmodalOpen(false);
            }}
          />
        )}
      </Modal>
      <Modal
        width="1080px"
        height="90%"
        title="Arbitrage de fin d'année"
        icon={<FaGlobe />}
        visible={modalOpenArbitrage}
        onClose={() => {
          setmodalOpenArbitrage(false);
        }}
      >
        {context.state.OptiRemListeContrat !== undefined && (
          <RemExpressArbitragePage
            ClientConjoint={""}
            visible={modalOpenArbitrage}
            onClose={() => {
              setmodalOpenArbitrage(false);
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default RemExpressSimulationPage;
